import http from "../../utils/http";

export const getAdministrativeCertificates = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/administrative-certificate/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addAdministrativeCertificate = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/administrative-certificate`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addAdministrativeCertificateSend = (sendType, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/administrative-certificate/send/${sendType}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};